
























































































import Vue from 'vue'
import { REQUIRED_LIST, DATA_TYPES } from '../commonDef'

export default Vue.extend({
  data() {
    return {
      // 当前正在编辑的行，为index 也就是sort-1
      editCol: '',
      requiredList: REQUIRED_LIST,
      dataTypes: DATA_TYPES,
      editObj: {
      },
      showColumns: [
        {
          dataIndex: 'action',
          key: 'action',
          title: '操作',  //"序号",
          width: 50,
          scopedSlots: { customRender: 'action' }
        },
        {
          dataIndex: 'name',
          key: 'name',
          title: '字段名称',
          width: 80,
          scopedSlots: { customRender: 'name' }
        },
        {
          dataIndex: 'isRequired',
          key: 'isRequired',
          title: '是否必填',
          width: 50,
          scopedSlots: { customRender: 'isRequired' }
        },
        {
          dataIndex: 'dataType',
          key: 'dataType',
          title: '数据类型',
          width: 50,
          scopedSlots: { customRender: 'dataType' }
        },
        {
          dataIndex: 'isSingleChoice',
          key: 'isSingleChoice',
          title: '是否单选',
          width: 50,
          scopedSlots: { customRender: 'isSingleChoice' }
        },
        {
          dataIndex: 'dataSource',
          key: 'dataSource',
          title: '数据源',
          width: 50,
          scopedSlots: { customRender: 'dataSource' }
        }
      ],
      // 被编辑的元数据
      sourceEditObj: {},
    }
  },

  created() {
    this.data.forEach((res,index) => {
      res.sort = index + 1
    })
  },
  props: {
    addFlag: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    // type 1 是是否必填 type为2 是是否是数据类型
    showText(text, type) {
      if (type === 1) {
        return this.findText(REQUIRED_LIST, text)
      } else if (type === 2) {
        return this.findText(DATA_TYPES, text)
      }
    },
    findText(arr,text) {
      return (arr.find(res => res.value === text) || {}).label
    },
    deleteRecord(record) {
      if (this.editCol !== '') {
        this.$message.info('请先完成其余行的操作')
        return
      }
      // 删除
      this.data.splice(record.sort - 1, 1)
      // 重新开始排序
      this.data.forEach((res, index) => {
        res.sort = index + 1
      })
    },
    edit(record) {
      if (this.editCol !== '') {
        this.$message.info('请先完成其余行的操作')
        return
      }
      this.sourceEditObj = {...record}
      this.editCol = record.sort - 1
      this.emitEditCol()
      this.editObj = {
        id: record.id,
        dataType: record.dataType,
        isSingleChoice: record.isSingleChoice || record.isSingleChoice === 0 ? record.isSingleChoice : undefined,
        name: record.name,
        isRequired: record.isRequired,
        dataSource: record.dataSource,
        editable:true,
        sort: record.sort
      }
      this.data.splice(record.sort - 1, 1, this.editObj)
    },
    emitEditCol() {
      this.$emit('editCol', this.editCol)
    },
    check() {
      if (!this.editObj.name) {
        this.$message.error('请输入字段名称')
        return
      }
      if (this.editObj.dataType === 2 || this.editObj.dataType === 4 ) {
        if(!this.editObj.dataSource) {// 数据类型为下拉/树选择，需要填写数据源
          this.$message.error('请输入数据源')
          return
        }
        if(!this.editObj.isSingleChoice && this.editObj.isSingleChoice!==0) {// 数据类型为下拉/树选择，需要选择是否单选
          this.$message.error('请选择是否单选')
          return
        }
      }
      this.data[this.editCol].editable = false
      // 储存完数据清空编辑情况
      this.clearEditStatus()
      // 透传数据
      this.$emit('sendWpData', this.data)
    },
    clearEditStatus () {
      this.editCol = ''
      this.editObj = {}
      this.emitEditCol()
    },
    close(sort) {
      if (this.sourceEditObj) {
        this.data.splice(sort - 1, 1, this.sourceEditObj)
      } else {
        this.data.splice(sort - 1, 1)
      }
      this.clearEditStatus()
    },
    add() {
      this.sourceEditObj = null
      this.editObj = {
        id: '',
        dataType: 0,
        name: '',
        isRequired:0,
        dataSource: '',
        isSingleChoice: undefined,
        editable:true,
        sort: this.data.length + 1,

      }
      this.editCol = this.data.length
      this.emitEditCol()
      this.data.push(this.editObj)
    },
    selectRequired(isRequired) {
      this.editObj.isRequired = isRequired
    },
    selectDataType(type) {
      this.editObj.dataType = type
      if (type !== 3) {
        this.editObj.dataSource = ''
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
})
